import React from 'react';
import { useSelector } from 'react-redux';
import MenubarContainer from '~/components/containers/MenubarContainer/MenubarContainer';
import useScrollHook from '~/hooks/use-scroll';
import type { AppState } from '~/reducers';
import * as S from './styled';

const ApplicationHeader: React.FC = () => {
  const isScrolling = useScrollHook();

  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  if (onWebView) {
    return null;
  }
  return (
    <S.Header $shadow={isScrolling} data-testid="application-header" id="application-header">
      <MenubarContainer />
    </S.Header>
  );
};

export default ApplicationHeader;
